const preconsentTemplate = `
<pwr-oauth-preconsent ></pwr-oauth-preconsent> 
`;

export default preconsentTemplate;
